/**
 * Strict validation for PlaneMesh's own properties, through the `v` combinators.
 * `flip_faces`, `material`, `custom_aabb`, `add_uv2` and `uv2_padding` are
 * `PrimitiveMesh`'s, and the base-walk delivers them to this class and QuadMesh.
 */
// Registers PrimitiveMesh and, through it, the rest of the chain, so the
// inherited keys resolve when this module loads alone.
import '../primitivemesh/linterValidators.js';
import { validatorRegistry } from '../../../linter/ValidatorRegistry.js';
import { v } from '../../../linter/validators/index.js';
import { PLANE_MESH_ORIENTATION_NAMES } from '../../../godot/scene/planeMesh.js';
validatorRegistry.registerAll('PlaneMesh', {
    // primitive_meshes.cpp:1515 (a Vector2, unlike the Vector3 `size` its BoxMesh
    // and QuadMesh-adjacent siblings take) and :1518.
    size: v.vector2('size'),
    center_offset: v.vector3('center_offset'),
    // primitive_meshes.cpp:1516-1517 hint "0,100,1,or_greater", so the ceiling is
    // open. The floor is the setter's: `set_subdivide_width` stores
    // `p_divisions > 0 ? p_divisions : 0` (:1543, and :1555 for depth), so a
    // negative subdivision is altered on the way in.
    subdivide_width: v.int('subdivide_width', { min: 0, enforced: 'primitive_meshes.cpp:1543' }),
    subdivide_depth: v.int('subdivide_depth', { min: 0, enforced: 'primitive_meshes.cpp:1555' }),
    // primitive_meshes.cpp:1519. `set_orientation` (:1575) is a bare assignment.
    orientation: v.enumInt('orientation', PLANE_MESH_ORIENTATION_NAMES, {
        hinted: 'primitive_meshes.cpp:1519',
    }),
});
//# sourceMappingURL=linterValidators.js.map